<template>
    <div class="grid grid-cols-2">
        <div>
            <AdminHTML v-model="modelValue" v-bind="$attrs" />
        </div>
        <div>
            <iframe
                class="w-full h-full"
                :srcdoc="preview"
                sandbox="allow-same-origin allow-scripts allow-modals allow-forms"
                frameborder="0"
                scrolling="no"
                allowfullscreen
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            ></iframe>
        </div>
    </div>
</template>

<script setup lang="ts">
import { watch, ref, Ref } from 'vue';
import type { FieldComponent } from '@src/Common/Components/types';
import { useToast } from '@src/Common/Composables/useToast';

const modelValue = defineModel({
    type: String,
});

const props = withDefaults(defineProps<FieldComponent>(), {
    source: '',
});

const preview: Ref<string> = ref<string>('');

const generate = (): void => {
    axios
        .post(props.source, {
            content: modelValue.value,
        })
        .then(({ data }) => {
            if (data.success) {
                preview.value = data.html;
            } else {
                useToast({
                    message: data.message,
                    type: 'error',
                });
            }
        })
        .catch((error) => {
            console.error(error);
        });
};

watch(
    () => modelValue.value,
    () => {
        generate();
    },
    {
        immediate: true,
    },
);
</script>
